const {component} = require('./AddToCartAppConfig');

module.exports = {
  default: {
    component,
  },
};
